export const arrowRight = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
<path d="M12.17 6.57784L8.59 9.95133L10 11.2763L16 5.63815L10 0L8.59 1.32496L12.17 4.69846H0V6.57784H12.17Z" fill="white"/>
</svg>`;